import React from 'react'
import { Text, View, StyleSheet, Image } from '@react-pdf/renderer'

const styles = StyleSheet.create({
    cover: {
        width: '100%',
        height: '100%',
        backgroundColor: '#f9fafe',
    },
    backgroundImage: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        bottom: 0,
        zIndex: -1,
    },
    coverCompany: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'start',
        paddingLeft: '5%',
        paddingRight: '9%',
        height: '100%',
        position: 'relative',
    },
    logoClientWrapper: {
        backgroundColor: '#fff',
        borderRadius: 5,
        paddingHorizontal: 3,
        paddingVertical: 1.5,
        alignSelf: 'flex-start',
        marginTop: 35,
        marginBottom: 6,
    },
    logoClientCover: {
        height: 28,
        width: 'auto',
        maxWidth: 140,
    },
});

const CoverDiff = ({ coverData, uiData, clientLogo }) => {
    const logoSrc = clientLogo || null;

    return (
        <View style={styles.cover}>
            <Image src={`${process.env.PUBLIC_URL}/bg-cover-diff.jpg`} style={styles.backgroundImage} />
            <View style={styles.coverCompany}>
                <Text style={{
                    color: '#B7B5B0',
                    fontFamily: 'Inter',
                    fontSize: 30,
                    fontWeight: 600,
                    lineHeight: 1.2,
                    width: '70%',
                    marginTop: 130,
                    letterSpacing: -1,
                }}>
                    {coverData.title}
                </Text>
                <View style={{
                    position: 'absolute',
                    top: '28.5%',
                    left: '6%',
                }}>
                    {logoSrc && (
                        <View style={styles.logoClientWrapper}>
                            <Image src={logoSrc} style={styles.logoClientCover} />
                        </View>
                    )}
                    <Text style={{
                        color: '#fff',
                        fontFamily: 'Inter',
                        fontSize: 45,
                        fontWeight: 600,
                        lineHeight: 1,
                        marginBottom: 12,
                        letterSpacing: -2,
                        ...( !logoSrc && { marginTop: 35 } )
                    }}>
                        {coverData.company}
                    </Text>
                    <Text style={{
                        color: '#fff',
                        fontFamily: 'Inter',
                        fontSize: 10,
                        fontWeight: 600,
                        marginBottom: 10,
                    }}>
                        {coverData.timestamp}
                    </Text>
                    <Text style={{
                        color: '#fff',
                        fontFamily: 'Inter',
                        fontSize: 12,
                    }}>
                        {uiData.manager}: {coverData.projektleiter}
                    </Text>
                </View>
            </View>

        </View>
    )
}

export default CoverDiff